import type { ComponentChildren } from "preact";
import { Link } from "wouter-preact";
import { useSiteConfig } from "../features/tenant/SiteConfigContext";
import { routes } from "../lib/route";
import "./PaymentLayout.css";

export function PaymentLayout({ children }: { children: ComponentChildren }) {
  const site = useSiteConfig();

  return (
    <div class="payment-layout">
      <header class="payment-header">
        {site.logoUrl && (
          <Link
            className="tenant-logo-link"
            href={routes.search()}
            aria-label="Go to payment search"
          >
            <img class="tenant-logo" src={site.logoUrl} alt={`${site.displayName} logo`} />
          </Link>
        )}
      </header>
      <main>{children}</main>
    </div>
  );
}
